const subways = {
  greenBranch: [
    '37',
    '38',
    '39',
    '40',
    '41',
    '42',
    '43',
    '44',
    '45',
    '46',
    '47',
    '48',
    '49',
    '50',
    '51',
    '52',
    '61',
    '74',
    '75',
    '76',
    '77',
    '78',
    '79',
    '80',
    '81',
    '82',
  ],
  blueBranch: [
    '19',
    '20',
    '21',
    '22',
    '23',
    '24',
    '25',
    '26',
    '27',
    '28',
    '29',
    '30',
    '31',
    '32',
    '33',
    '34',
    '35',
    '36',
    '66',
    '67',
    '68',
    '69',
    '70',
    '71',
    '72',
    '73',
  ],
  redBranch: [
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '10',
    '11',
    '12',
    '13',
    '14',
    '15',
    '16',
    '17',
    '18',
    '88',
    '72',
    '89',
    '53',
    '54',
    '55',
    '56',
    '57',
    '58',
    '59',
    '60',
    '61',
    '62',
    '63',
    '64',
    '65',
    '83',
    '84',
    '85',
    '86',
    '87',
    '88',
    '89',
    '90',
    '91',
  ],
};

export function branchColor(id) {
  if (subways.greenBranch.includes(String(id))) {
    return 'green';
  }

  if (subways.blueBranch.includes(String(id))) {
    return 'blue';
  }

  if (subways.redBranch.includes(String(id))) {
    return 'red';
  }

  return 'grey';
}
